import countries from 'constants/countries';

const isDevelopment = process.env.NODE_ENV === 'development';
const API_URL = isDevelopment ? process.env.REACT_APP_API_URL : window.config.api;
const API_SUBSCRIPTION_KEY = isDevelopment
  ? process.env.REACT_APP_SUBSCRIPTION_KEY
  : window.config.subscriptionkey;
const EXTERNAL_CLIENT_API_URL = isDevelopment
  ? process.env.REACT_APP_EXTERNAL_CLIENT_API_URL
  : window.config.externalApi;
const EXTERNAL_CLIENT_API_SUBSCRIPTION_KEY = isDevelopment
  ? process.env.REACT_APP_EXTERNAL_CLIENT_API_SUBSCRIPTION_KEY
  : window.config.externalSubscriptionkey;
const PUBLIC_URL = isDevelopment ? process.env.REACT_APP_OKTA_PUBLIC_URL : window.config.url;
const FULL_STORY_ID = isDevelopment
  ? process.env.REACT_APP_FULL_STORY_ID
  : window.config.fullstoryid;
const FULL_STORY_DEVMODE = isDevelopment
  ? process.env.REACT_APP_FULL_STORY_DEVMODE
  : window.config.fullstorydevmode;
const PENDO_APIKEY = isDevelopment ? process.env.REACT_APP_PENDO_API_KEY : window.config.pendokey;
const DATADOG_APPLICATION_ID = isDevelopment
  ? process.env.REACT_APP_DATADOG_APPLICATION_ID
  : window.config.datadogapplicationid;
const DATADOG_CLIENT_TOKEN = isDevelopment
  ? process.env.REACT_APP_DATADOG_CLIENT_TOKEN
  : window.config.datadogclienttoken;
const DATADOG_SITE = isDevelopment ? process.env.REACT_APP_DATADOG_SITE : window.config.datadogsite;
const DATADOG_SERVICE = isDevelopment
  ? process.env.REACT_APP_DATADOG_SERVICE
  : window.config.datadogservice;
const DATADOG_ENV = isDevelopment ? process.env.REACT_APP_DATADOG_ENV : window.config.datadogenv;
const TRACKING_SERVICES_KEY = isDevelopment
  ? process.env.REACT_APP_TRACKING_SERVICES_KEY
  : window.config.trackingserviceskey;

export const appConfig = {
  API_URL: API_URL,
  PUBLIC_URL: PUBLIC_URL,
  FULL_STORY_ID: FULL_STORY_ID,
  FULL_STORY_DEVMODE: FULL_STORY_DEVMODE === 'true',
  TRACKING_SERVICES_KEY: TRACKING_SERVICES_KEY,
  API_SUBSCRIPTION_KEY: API_SUBSCRIPTION_KEY,
  PENDO_APIKEY: PENDO_APIKEY,
  DATADOG_APPLICATION_ID: DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN: DATADOG_CLIENT_TOKEN,
  DATADOG_SITE: DATADOG_SITE,
  DATADOG_SERVICE: DATADOG_SERVICE,
  DATADOG_ENV: DATADOG_ENV,
  EXTERNAL_CLIENT_API_URL: EXTERNAL_CLIENT_API_URL,
  EXTERNAL_CLIENT_API_SUBSCRIPTION_KEY: EXTERNAL_CLIENT_API_SUBSCRIPTION_KEY,
  DEFAULT_COUNTRY: countries.US,
};
